import type { QueryClient } from '@tanstack/react-query'
import type { FlushResult } from './outbox'

/**
 * Nach einem Outbox-Flush die von nachgelieferten Schreibvorgängen betroffenen Anzeigen auffrischen — EINE
 * Wahrheit für beide Auslöser (Auto-Flush in main.tsx bei online/focus/boot UND der Konto-Flush im App-Effekt
 * nach dem Login). sent = direkt gebucht; converted = in einen Korrekturantrag umgewandelt (Nachzügler R2/1.4).
 */
export function invalidateAfterFlush(qc: QueryClient, result: FlushResult): void {
  if (result.sent === 0 && result.converted === 0) return
  void qc.invalidateQueries({ queryKey: ['orderTime'] })
  void qc.invalidateQueries({ queryKey: ['attendance'] })
  // nachgelieferte Stempel → Report/Timesheet/Chart; umgewandelte Nachzügler (202) → Korrekturliste (['zeiten','corrections']).
  void qc.invalidateQueries({ queryKey: ['zeiten'] })
}
